import React from 'react';
import styles from './ratingTrend.scss';

const RatingTrend = (props) => {
    const { ratingDisplay, ratingDifference, changeDirection, showDifferenceValue } = props;
    const valueToDisplay = showDifferenceValue ? Math.abs(ratingDifference).toFixed(2) : ratingDisplay;

    if (changeDirection?.toLowerCase() === 'up') {
        return (
            <span className={styles.ratingTrend}>
                <i className="utr utr-collapse" />
                <span>{valueToDisplay}</span>
            </span>
        );
    }
    if (changeDirection?.toLowerCase() === 'down') {
        return (
            <span className={styles.ratingTrend}>
                <i className="utr utr-expand" />
                <span>{valueToDisplay}</span>
            </span>
        );
    }
    if (changeDirection?.toLowerCase() === 'none') {
        return (
            <span className={styles.ratingTrend}>
                <span>{valueToDisplay}</span>
            </span>
        );
    }
    return (
        <span className={styles.ratingTrend}>--</span>
    );
};

export default RatingTrend;
